import { Box } from '@material-ui/core';
import React, { Fragment, useMemo } from 'react';
import { topBarMenusStyles } from './style';
import TopBarMenuItem, { ITopBarMenuItem } from './TopBarMenuItem';

interface Props {
  menuItems: ITopBarMenuItem[]
}

export default ({
  menuItems,
}: Props) => {

  const classes = topBarMenusStyles();
  const shown = useMemo((): boolean => {
    return menuItems && menuItems.length > 0;
  }, [menuItems])

  return (
    <Fragment>
      <div className={[
          classes.relativeWrapper,
          shown ? classes.shownRelativeWrapper : ''
        ].join(' ')}
      >

      </div>
      <Box
        boxShadow={ shown ? 4 : 0 }
        className={[
          classes.fixedWrapper,
          shown ? classes.shownFixedWrapper : ''
        ].join(' ')}
      >
        {
          menuItems.map((it: ITopBarMenuItem, key: number) => <TopBarMenuItem { ...it } key={ key } />)
        }
      </Box>
    </Fragment>
  )
}